import React from 'react'
import { Field, ErrorMessage } from 'formik'

const InputField = ({
  name,
  placeholder,
  text,
  as = 'input',
  children,
  backgroundtype = 'dark',
}) => {
  return (
    <div className="bg-gray-50 py-1">
      <label
        className="text-sm leading-5 font-medium text-white text-right"
        htmlFor={name}>
        {text}
      </label>
      <Field
        id={name}
        as={as}
        name={name}
        placeholder={placeholder}
        className={`w-full bg-white text-black border rounded-lg py-3 px-4 ${
          backgroundtype === 'dark' ? `border-white` : `border-gray-600`
        }`}>
        {children ? children : null}
      </Field>
      <ErrorMessage
        name={name}
        component="div"
        className="text-red-500 text-xs"
      />
    </div>
  )
}

export default InputField
